import { COMMISSIONS_POLICIES_ADD_BASIC_INFORMATION } from '../constants'

export function reducer(state, action) {
  if (action.type === COMMISSIONS_POLICIES_ADD_BASIC_INFORMATION) {
      return {
        ...state,
        policies: {
          ...state.policies,
          basicInformation: { ...action.data }
        }
      }
  }
  else {
    return state
  }
}
